import { Chip } from "@mui/material";
import { Datagrid, FunctionField, List, TextField, useRecordContext } from "react-admin";

import { MODEL_LABEL, partnerStatus } from "./status";

export type PartnerRecord = {
  id: string;
  user_id: string;
  user_phone: string | null;
  model: string;
  status: string;
  code: string | null;
  markup_pct: number;
  fraud_flags: { code: string; detail?: string; at?: string }[];
  balance: {
    pending_usd: number;
    hold_usd: number;
    available_usd: number;
    paid_usd: number;
    total_earned_usd: number;
  };
};

function StatusChip() {
  const record = useRecordContext<PartnerRecord>();
  if (!record) return null;
  const s = partnerStatus(record.status);
  return <Chip size="small" color={s.color} label={s.label} />;
}

export function PartnerList() {
  return (
    <List perPage={50} sort={{ field: "created_at", order: "DESC" }} exporter={false}>
      <Datagrid rowClick="show" bulkActionButtons={false}>
        <FunctionField label="Статус" render={() => <StatusChip />} />
        <TextField source="user_phone" label="Телефон" />
        <FunctionField label="Модель" render={(r: PartnerRecord) => MODEL_LABEL[r.model] ?? r.model} />
        <FunctionField label="Код" render={(r: PartnerRecord) => (r.code ? r.code.toUpperCase() : "—")} />
        <FunctionField
          label="Наценка"
          render={(r: PartnerRecord) => (r.model === "agent" ? `+${Number(r.markup_pct)}%` : "—")}
        />
        <FunctionField
          label="Доступно, $"
          render={(r: PartnerRecord) => Number(r.balance?.available_usd ?? 0).toFixed(2)}
        />
        <FunctionField
          label="В холде, $"
          render={(r: PartnerRecord) => Number(r.balance?.hold_usd ?? 0).toFixed(2)}
        />
        <FunctionField
          label="Антифрод"
          render={(r: PartnerRecord) =>
            r.fraud_flags?.length ? <Chip size="small" color="error" label={r.fraud_flags.length} /> : "—"
          }
        />
      </Datagrid>
    </List>
  );
}
